import { Component } from '@angular/core';

@Component({
    selector: 'app-chartjs-tooltip',
    standalone: true,
    imports: [],
    templateUrl: './chartjs-tooltip.component.html',
    styleUrl: './chartjs-tooltip.component.scss',
})
export class ChartjsTooltipComponent {}
